import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Accordion from 'react-bootstrap/Accordion';
import { GetCacheKey } from '../../../services/common/utils';
import Loadingcomponent from '../../loader/loadingcomponent';
import ErrorMessage from '../../messaging/errormessage';
import AccordionItem from './accordion-item';
import { useTranslation } from 'react-i18next';
import NojoomHotDealsShimmer from '../../../ShimmerEffect/NojoomHotDealsShimmer';

const AccordionMain = ({ pmsitem, isNojoomPageMaster }) => {
  const [selected, setselected] = useState(['0']);
  const { t } = useTranslation();
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
  } = useQuery(
    [
      GetCacheKey(pmsitem?.uniqueid),
      pmsitem.method,
      JSON.parse(pmsitem.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  if ((isLoading || isFetching ) && isNojoomPageMaster) {
    return <></> //<NojoomHotDealsShimmer/>;
  }else if(isLoading || isFetching){
    return <Loadingcomponent message={'Loading'} />;
  }

  if (error || isError || isLoadingError) {
    return <>
        <div className="xpress_no_trans text-center" >
          <img
            src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
            alt=""
            title=""
          />
          <div className="mb-5">
            <label>{t("somethingwentwrong")}</label>
          </div>
        </div>
      </>;
  }

  const getAccordianItem = (item, idx) => {
    switch (item?.templatetype) {
      // Special Deals
      case '104': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={2}
            eventKey={String(idx)}
            redirectTo="/special-deals"
          />
        );
      }

      // Special Deals - Postpaid
      case '112': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={13}
            eventKey={String(idx)}
            redirectTo="/special-deals"
          />
        );
      }

      // Digital Services
      case '107': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={5}
            eventKey={String(idx)}
            redirectTo="/digitalservices"
          />
        );
      }

      // Addons
      case '117': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={8}
            eventKey={String(idx)}
            redirectTo="/addonshome"
          />
        );
      }

      //Roaming
      case '108': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={9}
            eventKey={String(idx)}
            redirectTo="/roaming"
          />
        );
      }
      //Ooredoo ADD
      case '166': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={18}
            eventKey={String(idx)}
            redirectTo={item?.metadata?.more_url}
          />
        );
      }


      // Bundles
      case '105': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={15}
            eventKey={String(idx)}
            redirectTo="/bundles"
          />
        );
      }

      // Nojoom - Hot Deals
      case '203': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo={item?.metadata?.more_url}
            section='hot-deals'
            isNojoomPageMaster={isNojoomPageMaster}
          />
        );
      }

      // Nojoom - Partners 
      case '204': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo="/nojoom-partners"
            section='partners'
            isNojoomPageMaster={isNojoomPageMaster}
          />
        );
      }

      // Nojoom - Ooredoo Services 
      case '205': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo=""
            section='services'
            isNojoomPageMaster={isNojoomPageMaster}
          />
        );
      }

      // Nojoom - Earn Points 
      case '206': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo=""
            section='earn-points'
          />
        );
      }

      // Nojoom - Transfer Points
      case '207': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo=""
            section='transfer-points'
          />
        );
      }

      // Nojoom - Transfer Points - Changed
      case '173': {
        return (
          <AccordionItem
            selecteditems={selected}
            item={item}
            type={16}
            eventKey={String(idx)}
            redirectTo="/transferPoints-home"
            section='transfer-points'
            isNojoomPageMaster={isNojoomPageMaster}
          />
        );
      }

      default: {
        return <></>;
      }
    }
  };

  return (
    <Accordion
      className="accordion_style_1"
      defaultActiveKey={['0']}
      alwaysOpen={false}
      onSelect={(e) => {
        setselected(e);
      }}
    >
      {data?.data?.map((item, idx) => {
        return (
          <React.Fragment key={`index-${idx}`}>
            {getAccordianItem(item, idx)}
          </React.Fragment>
        );
      })}

      {/* Commented for UI team reference */}
      {/* <Accordion.Item className='accordion_item' eventKey="0">
        <Accordion.Header className='accordion_header'>
            <h3 className="section_title mb-0">Special Deals</h3>
            <img src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'} alt="" title="" />
        </Accordion.Header>
        <Accordion.Body className='accordion_collapse'>
            <div className='accordion_collapse_in'>
                <SwiperComponent type={2}></SwiperComponent>
                <button className="custom_btn custom_btn_primary_outline btn_block">View All</button>
            </div>
        </Accordion.Body>
    </Accordion.Item>
      <Accordion.Item className='accordion_item' eventKey="1">
        <Accordion.Header className='accordion_header'>
            <h3 className="section_title mb-0">Special Deals 1</h3>
            <img src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'} alt="" title="" />
        </Accordion.Header>
        <Accordion.Body className='accordion_collapse'>
            <div className='accordion_collapse_in'>
                <SwiperComponent type={3}></SwiperComponent>
                <button className="custom_btn custom_btn_primary_outline btn_block">View All</button>
            </div>
        </Accordion.Body>
    </Accordion.Item>
      <Accordion.Item className='accordion_item' eventKey="2">
        <Accordion.Header className='accordion_header'>
            <h3 className="section_title mb-0">Bundles</h3>
            <img src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'} alt="" title="" />
        </Accordion.Header>
        <Accordion.Body className='accordion_collapse'>
            <div className='accordion_collapse_in'>
                <SwiperComponent type={4}></SwiperComponent>
                <button className="custom_btn custom_btn_primary_outline btn_block">View All</button>
            </div>
        </Accordion.Body>
    </Accordion.Item>
      <Accordion.Item className='accordion_item' eventKey="2">
        <Accordion.Header className='accordion_header'>
            <h3 className="section_title mb-0">Digital Services</h3>
            <img src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'} alt="" title="" />
        </Accordion.Header>
        <Accordion.Body className='accordion_collapse'>
            <div className='accordion_collapse_in'>
                <SwiperComponent type={5}></SwiperComponent>
                <button className="custom_btn custom_btn_primary_outline btn_block">View All</button>
            </div>
        </Accordion.Body>
    </Accordion.Item>
      <Accordion.Item className='accordion_item' eventKey={eventKey}>
        <Accordion.Header className='accordion_header'>
            <h3 className="section_title mb-0">{pmsitem?.metadata?.title}</h3>
            <img src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'} alt="" title="" />
        </Accordion.Header>
        <Accordion.Body className='accordion_collapse'>
            <div className='accordion_collapse_in'>
                {getAccordianContent(pmsitem?.templatetype)}
                <button className="custom_btn custom_btn_primary_outline btn_block">{pmsitem?.metadata?.more_title}</button>
            </div>
        </Accordion.Body>
    </Accordion.Item> */}
    </Accordion>
  );
};
export default AccordionMain;
